export default "__VITE_PUBLIC_ASSET__85317604__"